export enum OutkeepPermission {
  LogistViewRequest = 'logistViewRequest', // Отображение доступной заявки
  LogistCreateRequests = 'logistCreateRequests', // Создание заявки
  LogistViewScheduleOwners = 'logistViewScheduleOwners',
  LogistViewAllAsSelected = 'logistViewAllAsSelected',
  LogistChangeRequestStatus = 'logistChangeRequestStatus',
  LogistViewObd = 'logistViewObd',
  LogistRatingControlView = 'logistRatingControlView', // ОКК
  LogistRatingControlSet = 'logistRatingControlSet', // изменять ОКК
  LogistRatingSet = 'logistRatingSet',
  LogistRatingFullAccess = 'logistRatingFullAccess',
  LogistEditActualDeliveryAddress = 'logistEditActualDeliveryAddress',
  LogistEditRequestsResetAddress = 'logistEditRequestsResetAddress',
  LogistViewProducts = 'logistViewProducts',
  LogistCanCompleteProducts = 'logistCanCompleteProducts',
  LogistAddDevices = 'logistAddDevices',
  LogistViewDevices = 'logistViewDevices',
  LogistViewDeviceLink = 'logistViewDeviceLink',
  LogistDevicesUpdateLocation = 'logistDevicesUpdateLocation',
  LogisticTempActAlfaDownload = 'logisticTempActAlfaDownload',
  LogistAllFilesView = 'logistAllFilesView',
  LogistOtherFilesView = 'logistFilesView',
  LogistViewPrivateCarPhotos = 'logistViewPrivateCarPhotos', // Просмотр фото ПЛ
  LogistViewPhotoPlInstall = 'logistViewPhotoPlInstall', // Просмотр фото ПЛ (местная установка)
  LogistViewPhotoObd = 'logistViewPhotoObd', // Просмотр фото ОБД
  LogistViewPhotoVIN = 'logistViewPhotoVIN', // Просмотр фото VIN
  LogistViewPhotoMarkingPlace = 'logistViewPhotoMarkingPlace', // Просмотр фото места маркировки
  LogistViewPhotoKeys = 'logistViewPhotoKeys', // Просмотр фото ключей
  LogistViewPhotoSLS = 'logistViewPhotoSLS', // Просмотр фото СЛС
  LogistViewPhotoPassportLP = 'logistViewPhotoPassportLP', // Просмотр фото паспорта ЛП
  LogistViewObrzPtsPsm = 'logistViewObrzPtsPsm', // Просмотр образца ПТС/ПСМ
  LogistFilesUpload = 'logistFilesUpload',
  LogistOnlyOwnerFilesUpload = 'logistOnlyOwnerFilesUpload',
  LogistOnlyContractorFilesUpload = 'logistOnlyContractorFilesUpload',
  LogistViewAnketaTrekera = 'logistViewAnketaTrekera',
  LogistOnlyOwnerFilesRemove = 'logistOnlyOwnerFilesRemove',
  LogistOnlyContractorFilesRemove = 'logistOnlyContractorFilesRemove',
  LogistViewComments = 'logistViewComments',
  LogistAddComments = 'logistAddComments',
  LogistDeleteComments = 'logistDeleteComments',
  LogistFilesRemove = 'logistFilesRemove',
  LogistEditRequestsOfAnyContractor = 'logistEditRequestsOfAnyContractor',
  LogistEditDealDetails = 'logistEditDealDetails',
  LogistUseBetaOutkeep = 'logistUseBetaOutkeep',
  LogistCanSendRequestByEmail = 'logistCanSendRequestByEmail',
  LogistDevicesInstallQuality = 'logistDevicesInstallQuality',
  LogistViewAllRequests = 'logistViewAllRequests',
  LogistViewMyRequests = 'logistViewMyRequests', // Для установщика (мои - те, где я назначен установщиком)
  LogistViewRequestsForUs = 'logistViewRequestsForUs', // "Наши" (мы - исполнитель)
  LogistViewMyOwnRequests = 'logistViewMyOwnRequests', // Созданные мной лично
  LogistViewCompanyRequests = 'logistViewCompanyRequests', // Заявки, созданные моей компанией
  LogistViewMySubdivisionRequests = 'logistViewMySubdivisionRequests', // Доступ к заявкам моих подразделений
  LogistViewAccessibleCounterpartiesRequests = 'logistViewAccessibleCounterpartiesRequests', // Доступ к заявкам контрагентов из списка доступа для текущего физ. лица
  LogistViewCounterpartiesAccessPointsRequests = 'logistViewCounterpartiesAccessPointsRequests', // Доступ к заявке по точке доступа контрагента заявки
  LogistViewSpecificRequestsList = 'logistViewSpecificRequestsList', // Доступ к заявкам из индивидуального списка
  LogistCreateTemporaryAccess = 'logistCreateTemporaryAccess', // Создание временного доступа к заявкам
  LogistViewCompletedRequests = 'logistViewCompletedRequests', // Доступ к выполненным заявкам
  LogistOn = 'logistOn', // 'Заявки на установку' -> 'Отображение в меню'
  Status = 'status',
  SystemApiInstallRequestsUploadFile = 'systemApi_installRequests_UploadFile', // Загрузка файлов заявок через системный API
  LogistDevicesPreviewStatuses = 'logistDevicesPreviewStatuses', // Просмотр статусов устройств (dataProcessed)
  Warehouse = 'warehouse', // Склад бета (Склад 2)
  WarehouseOn = 'warehouseOn', // Отображение в меню Склад(бета)
  Payroll = 'payroll', // Начисления
  PayrollOn = 'payrollOn', // Отображение в меню Начисления
  LogistDocFlowOn = 'logistDocFlowOn', // Отображение в меню Документооборот
  LogistProductsInstallerView = 'logistProductsInstallerView', // Видит альтернативных исполнителей товаров и услуг
  EditRequestProductInstaller = 'editRequestProductInstaller', // Управление альтернативными исполнителями товаров и услуг
  LogistTravelCostAccess = 'logistTravelCostAccess', // Доступ к стоимости выезда/альтернативного исполнителя
  LogistEditRequestsFull = 'logistEditRequestsFull', // Управление СЛС товаров/услуг
  LogistChangeInstaller = 'logistChangeInstaller', // 'Смена/выбор установщика'
  LogistViewRequestTypes = 'logistViewRequestTypes', // Типы заявок
  LogistViewDefaultRequests = 'logistViewDefaultRequests', // Стандартные заявки
  LogistViewRegistrationRequests = 'logistViewRegistrationRequests', // Регистрационные заявки
  LogistViewRepossessionRequests = 'logistViewRepossessionRequests', // Заявки с изъятием
  LogistTimeManagement = 'logistTimeManagement', // Тайм менеджмент логистов
  LogistTimeManagementOn = 'logistTimeManagementOn', // Тайм менеджмент логистов отображение в меню
  LogistTimeManagementEdit = 'logistTimeManagementEdit', // Управление заявками в тайм-менеджменте
  LogistReservationsOn = 'logistReservationsOn', // Управление бронями в тайм-менеджменте
  LogistViewCounterpartyAccessPointFieldInRequestCreation = 'logistViewCounterpartyAccessPointFieldInRequestCreation', // Видит поле Точка заказчика в форме создания заявки
  LogistReleaseCityBlock = 'logistReleaseCityBlock', // Работа с Городом выдачи

  /* Регламенты */
  LogistWorkflowsSetupView = 'logistWorkflowsSetupView', // Просмотр конфигурации регламентов
  LogistWorkflowsSetupManage = 'logistWorkflowsSetupManage', // Управление конфигурацией регламентов

  LogistRequestWorkflowsView = 'logistRequestWorkflowsView', // Просмотр регламентов заявок,
  LogistRequestWorkflowsExecutionMy = 'logistRequestWorkflowsExecutionMy', // Выполнение только своих регламентов заявок,
  LogistRequestWorkflowsExecutionAll = 'logistRequestWorkflowsExecutionAll', // Выполнение любых регламентов заявок
  LogistRequestWorkflowsManage = 'logistRequestWorkflowsManage', // Управление регламентами заявок
}
